import React from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  IconButton,
  InputBase,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const PayInFilters = ({
  fromDate,
  toDate,
  searchQuery,
  setFromDate,
  setToDate,
  setSearchQuery,
  handleSearch,
  handleClear,
}) => {
  return (
    <Paper
      sx={{
        padding: "2rem",
        borderRadius: "10px",
        marginTop: "2%",
        boxShadow:"none"
      }}
    >
      <Grid container spacing={2}>
        {/* Date Inputs */}
        <Grid item xs={12} sm={6} md={6}>
          <TextField
            label="From Date"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <TextField
            label="To Date"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>

        {/* Search and Buttons */}
        <Grid
          item
          xs={12}
          sx={{
            marginTop: "1%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          {/* Search Field */}
          <Box
            sx={{
              display: "flex",
              flex: 1,
              maxWidth: { xs: "100%", sm: "50%" },
              borderRadius: "10px",
              border: "1px solid rgba(0, 0, 0, 0.3)",
              padding: "0.5rem",
              backgroundColor: "#fff",
              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
            }}
          >
            <InputBase
              fullWidth
              placeholder="Search transactions..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ paddingLeft: "10px" }}
            />
            <IconButton color="primary" onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <Button
              onClick={handleSearch}
              sx={{
                backgroundColor: "#027BFE",
                color: "white",
                height: "56px",
                textTransform: "none",
                borderRadius: "10px",
                width: { xs: "100%", sm: "120px" },
                "&:hover": {
                  backgroundColor: "#0260D0",
                },
              }}
            >
              Search
            </Button>
            <Button
              onClick={handleClear}
              sx={{
                backgroundColor: "gray",
                color: "white",
                height: "56px",
                textTransform: "none",
                borderRadius: "10px",
                width: { xs: "100%", sm: "120px" },
                "&:hover": {
                  backgroundColor: "#5A5A5A",
                },
              }}
            >
              Clear
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PayInFilters;
